import React from "react";
import {
  Phone,
  Mail,
  MapPin,
 Clock3,
  ArrowRight,
} from "lucide-react";
import Header from "../components/Header";

const Contact = () => {
  const contacts = [
    {
      icon: <Phone size={26} />,
      title: "Call Us",
      value: "0261 360 0552",
      sub: "Available Monday to Saturday",
      href: "tel:0261 360 0552",
    },
    {
      icon: <Mail size={26} />,
      title: "Email",
      value: "support@smeerahealth.com",
      sub: "We'll reply within 24 hours",
      href: "mailto:support@smeerahealth.com",
    },
    {
      icon: <MapPin size={26} />,
      title: "Office",
      value: "Shop-203 , Green Elina Opp Sneh Sankul Wadi,",
      sub: "Adajan, Surat, Gujarat 395009",
    },
    {
      icon: <Clock3 size={26} />,
      title: "Working Hours",
      value: "10:00 AM - 6:30 PM",
      sub: "Sunday Closed",
    },
  ];

  return (
    <>
    <Header/>
    <main className="bg-[#F8F8F5]">

      {/* HERO */}

      <section className="relative overflow-hidden pt-16 pb-16  md:pb-36">

        <div className="absolute left-0 top-0 h-80 w-80 rounded-full bg-[#D4CB2F]/10 blur-[120px]" />

        <div className="absolute right-0 bottom-0 h-80 w-80 rounded-full bg-[#55534F]/10 blur-[120px]" />

        <div className="theme-container relative z-10 mx-auto text-center">

          <span className="inline-flex rounded-full bg-[#D4CB2F]/10 border border-[#D4CB2F]/20 px-6 py-2 text-[12px] md:text-sm font-semibold uppercase tracking-[4px] text-[#353204]">
            Contact Us
          </span>

          <h1 className="mt-8 text-3xl md:text-6xl font-black text-[#3F3D3A] leading-tight">
            We'd Love To
            <br />
            <span className="bg-gradient-to-r from-[#D4CB2F] to-[#55534F] text-transparent bg-clip-text">
              Hear From You
            </span>
          </h1>

          <p className="mt-6 md:mt-8 max-w-3xl mx-auto text-base md:text-lg leading-8 text-[#666]">
            Whether you're looking for healthcare plans, have questions about
            our services, or simply need guidance, our team is always ready to
            help.
          </p>

        </div>

      </section>

      {/* CONTACT */}

      <section className="pb-16 md:pb-24">

        <div className="theme-container mx-auto">

          <div className="grid lg:grid-cols-2 gap-14 items-center">

            {/* LEFT */}

            <div>

              <div className="grid sm:grid-cols-2 gap-6">

                {contacts.map((item, index) => (

                  <a
                    href={item.href}
                    key={index}
                    className="
                    group
                    relative
                    overflow-hidden
                    rounded-[28px]
                    bg-white
                    p-7
                    shadow-[0_10px_40px_rgba(0,0,0,.05)]
                    transition-all
                    duration-500
                    hover:-translate-y-2
                    hover:shadow-[0_25px_60px_rgba(212,203,47,.18)]
                  "
                  >

                    <div
                      className="
                      absolute
                      left-0
                      top-0
                      h-full
                      w-0
                      bg-[#D4CB2F]
                      transition-all
                      duration-500
                      group-hover:w-2
                    "
                    />

                    <div
                      className="
                      h-14
                      w-14
                      rounded-2xl
                      bg-[#D4CB2F]/10
                      flex
                      items-center
                      justify-center
                      text-[#D4CB2F]
                      transition-all
                      duration-500
                      group-hover:bg-[#D4CB2F]
                      group-hover:text-white
                    "
                    >
                      {item.icon}
                    </div>

                    <h3 className="mt-6 text-xl font-bold bg-gradient-to-r from-[#D4CB2F] to-[#55534F] text-transparent bg-clip-text">
                      {item.title}
                    </h3>

                    <p className="mt-3 font-semibold text-[#55534F] break-words">
                      {item.value}
                    </p>

                    <p className="mt-2 text-sm text-[#888]">
                      {item.sub}
                    </p>

                  </a>

                ))}

              </div>

            </div>

            {/* RIGHT */}

            <div className="relative group">

              <div className="overflow-hidden rounded-[36px]">

                <img
                  src="assets/images/contact.jpg"
                  alt=""
                  className="
                  h-full
                  w-full
                  object-cover
                  transition-all
                  duration-700
                  group-hover:scale-105
                "
                />

              </div>

              <div
                className="
                absolute
                bottom-8
                left-8
                rounded-3xl
                bg-white
                px-8
                py-6
                shadow-[0_20px_60px_rgba(0,0,0,.15)]
              "
              >
                <p className="text-3xl font-black bg-gradient-to-r from-[#D4CB2F] to-[#55534F] text-transparent bg-clip-text">
                  10K+
                </p>

                <p className="font-semibold text-[#3F3D3A]">
                  Happy Families
                </p>

                <p className="text-sm text-[#666]">
                  Trusted Healthcare Partner
                </p>

              </div>

            </div>

          </div>

        </div>

      </section>

      {/* CTA */}

      <section className="pb-24">

        <div className="theme-container mx-auto">

          <div className="rounded-[36px] bg-[#3F3D3A] px-8 py-16 md:px-20 flex flex-col lg:flex-row items-center justify-between gap-10">

            <div>

              <p className="uppercase tracking-[4px] text-[#D4CB2F] font-semibold">
                Need Assistance?
              </p>

              <h2 className="mt-4 text-3xl md:text-5xl font-black text-white leading-tight">
                Let's Build A Healthier
                <br />
                Future Together
              </h2>

            </div>

            {/* <a
              href="tel:+919711300776"
              className="
              group
              rounded-full
              bg-[#D4CB2F]
              px-8
              py-4
              font-semibold
              text-[#3F3D3A]
              transition
              duration-300
              hover:scale-105
              flex
              items-center
              gap-3
            "
            >
              Contact Now

              <ArrowRight
                className="transition group-hover:translate-x-2"
                size={20}
              />

            </a> */}

          </div>

        </div>

      </section>

    </main>
    </>
  );
};

export default Contact;